import React from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { withStyles } from '@material-ui/core/styles';
import ArrowRight from '@material-ui/icons/ArrowRight';
import Table from '@material-ui/core/Table';
import { Pagination, Skeleton } from '@iris-platform/iris-react-ui';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Collapse } from '@material-ui/core';
import classNames from 'classnames';
import * as _ from 'lodash';
import { toString } from 'ramda';
import { GET_CALL_DETAILS } from './queries';
import {
  stylesToPropType,
} from '../../utils';
import DataProcessor from './dataprocessor';

const styles = theme => ({
  root: {
    width: '100%',
    // marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
    padding: 0,
  },
  table: {
    minWidth: '100%',
  },
  inactive: {
    display: 'none',
  },
  success: {
    color: '#86C35D',
  },
  info: {
    // color: '#86C35D',
  },
  failure: {
    color: '#DC2620',
  },
  carot: {
    transform: 'rotate(0deg)',
    transition: 'transform 0.5s linear',
  },
  expand: {
    transform: 'rotate(90deg)',
    transition: 'transform 0.5s linear',
  },
  rowTable: {
    fontSize: '14px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    paddingLeft: '2px',
    paddingRight: '4px',
    // textAlign: 'center',
  },
  cellTable: {
    fontSize: '12px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    paddingLeft: '2px',
    paddingRight: '4px',
  },
  failureRow: {
    fontSize: '12px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    paddingLeft: '2px',
    paddingRight: '4px',
    color: '#DC2620',
    fontWeight: 'bold',
  },
  noRecords: {
    textAlign: 'center',
    color: 'red',
    fontSize: '15px',
    padding: '10px',
    margin: '15px auto',
    border: '1px dotted red',
  },

});

class CallDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentPage: 1, callDetailsData: [] };
    this.handleArrowClick = this.handleArrowClick.bind(this);
    this.renderAdditionalInfo = this.renderAdditionalInfo.bind(this);
    this.onClickPage = this.onClickPage.bind(this);
    this.loadCallsDetails = this.loadCallsDetails.bind(this);
  }

  componentWillMount = async () => {
    let { callDetailsData } = this.props;
    callDetailsData = callDetailsData.filter((c, i) => i >= 0 && i < 10);
    const newCallDetailsData = await this.loadCallsDetails(callDetailsData);
    this.setState({ callDetailsData: newCallDetailsData });
  }

  loadCallsDetails = async (callsList) => {
    const {
      startTime,
      endTime,
      client,
    } = this.props;
    const traceIdList = [];
    Object.keys(callsList).forEach((idx) => {
      if (callsList[idx] !== undefined) {
        traceIdList.push(callsList[idx].traceId);
      }
    });
    const callsData = [...callsList];
    const newCallDetailsData = [];
    try {
      const callDetails = await client.query({
        query: GET_CALL_DETAILS,
        fetchPolicy: 'network-only',
        variables: {
          startTime: toString(startTime),
          endTime: toString(endTime),
          traceIds: traceIdList,
        },
      });
      let pageCallDetails = [];
      if (callDetails.data.getCallDetails.traceIds.buckets !== undefined) {
        pageCallDetails = DataProcessor(callDetails.data.getCallDetails.traceIds.buckets);
      }
      Object.keys(callsData).forEach((idx) => {
        if (callsData[idx] !== undefined) {
          const detailInfo = pageCallDetails[callsData[idx].traceId];
          if (detailInfo !== undefined) {
            callsData[idx].fromTN = detailInfo.srcTN;
            callsData[idx].toTN = detailInfo.dstTN;
            callsData[idx].callStatus = detailInfo.callStatus;
            callsData[idx].milestones = detailInfo.values;
            newCallDetailsData.push(callsData[idx]);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
    return newCallDetailsData;
  }

  onClickPage = async (currentPage) => {
    const {
      callDetailsData,
    } = this.props;
    const callsData = callDetailsData.filter((c, i) => (
      (currentPage - 1) * 10) <= i && i < (currentPage * 10));
    const newCallDetailsData = await this.loadCallsDetails(callsData);
    this.setState({ currentPage, callDetailsData: newCallDetailsData });
  }

  formatTime = (date) => {
    const dateString = date ? new Date(date).toLocaleString() : 'Incomplete/Missing';
    return dateString;
  }

  handleArrowClick = (data, index) => {
    const { callData } = this.state;
    let callDetail = { index };
    if (callData && index === callData.index) {
      callDetail = null;
    }
    this.setState({ callData: callDetail });
  }

  renderAdditionalInfo(callData) {
    const { classes } = this.props;
    const milestones = [...callData.milestones];

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.rowTable}>Milestone</TableCell>
            <TableCell className={classes.rowTable}>Time</TableCell>
            <TableCell className={classes.rowTable}>Category</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { milestones.map((milestone) => {
            const className = (milestone.milestoneStatus === 'info') ? classes.cellTable : classes.failureRow;
            const keyName = `${callData.traceId}_${milestone.milestone}_${parseInt(milestone.timestamp, 10)}`;
            return (
              <TableRow key={keyName}>
                <TableCell className={className} component="th" scope="row">
                  {milestone.milestoneDisplay}
                </TableCell>
                <TableCell className={className} component="th" scope="row">
                  {this.formatTime(parseInt(milestone.timestamp, 10))}
                </TableCell>
                <TableCell className={className} component="th" scope="row">
                  {milestone.milestoneStatus}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { callDetailsData } = this.state;
    const { classes } = this.props;
    if (this.props.callDetailsData.length === 0) {
      return <div className={classes.noRecords}>No Call Records Found</div>;
    }
    return (
      <div className={classes.callDetailsWrapper}>
        <Table className={classes.table} padding="dense">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell className={classes.rowTable}>Originator Address</TableCell>
              <TableCell className={classes.rowTable}>Destination Address</TableCell>
              <TableCell className={classes.rowTable}>Start Time</TableCell>
              <TableCell className={classes.rowTable}>Call Status</TableCell>
              <TableCell className={classes.rowTable}>Trace</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              callDetailsData.length === 0
                ? (
                  <TableRow>
                    <TableCell className={classes.cellTable} component="th" scope="row">
                      <ArrowRight />
                    </TableCell>
                    <TableCell className={classes.cellTable} component="th" scope="row">
                      {' '}
                      <Skeleton />
                      {' '}
                    </TableCell>
                    <TableCell className={classes.cellTable} component="th" scope="row">
                      {' '}
                      <Skeleton />
                      {' '}
                    </TableCell>
                    <TableCell className={classes.cellTable} component="th" scope="row">
                      {' '}
                      <Skeleton />
                      {' '}
                    </TableCell>
                    <TableCell className={classes.cellTable} component="th" scope="row">
                      {' '}
                      <Skeleton />
                      {' '}
                    </TableCell>
                  </TableRow>
                )
                : callDetailsData.map((callData, index) => {
                  const showInfo = this.state.callData && (this.state.callData.index === index);
                  const className = (callData.callStatus === 'Success' || callData.callStatus === 'success') ? classes.success : classes.failure;
                  return [
                    <TableRow key={callData.traceId}>
                      <TableCell className={classes.cellTable} component="th" scope="row" onClick={() => this.handleArrowClick(callData, index)}>
                        <ArrowRight
                          className={classNames(classes.carot, { [classes.expand]: showInfo })}
                        />
                      </TableCell>
                      <TableCell className={classes.cellTable} component="th" scope="row">
                        {callData.fromTN ? callData.fromTN : 'Incomplete/Missing'}
                      </TableCell>
                      <TableCell className={classes.cellTable} component="th" scope="row">
                        {callData.toTN ? callData.toTN : 'Incomplete/Missing'}
                      </TableCell>
                      <TableCell className={classes.cellTable} component="th" scope="row">
                        {this.formatTime(callData.createdAt)}
                      </TableCell>
                      <TableCell className={classes.cellTable} component="th" scope="row">
                        <div className={className}>
                          {callData.callStatus}
                        </div>
                      </TableCell>
                      <TableCell className={classes.cellTable} component="th" scope="row">
                        <a href={`https://reports.iris.comcast.net/calltrace-detail?traceId=${callData.traceId}&earliest=${(callData.createdAt - 1 * 60 * 60 * 1000)}&latest=${(callData.createdAt + 48 * 60 * 60 * 1000)}&env=prod`} rel="noopener noreferrer" target="_blank">
                        Trace
                        </a>
                      </TableCell>
                    </TableRow>,
                    <TableRow key={`${callData.traceId}.details`} className={showInfo ? classes.active : classes.inactive}>
                      <TableCell className={classes.cellTable} colSpan={2} />
                      <TableCell className={classes.cellTable} colSpan={4}>
                        <Collapse in={showInfo}>
                          {this.renderAdditionalInfo(callData)}
                        </Collapse>
                      </TableCell>
                    </TableRow>,
                  ];
                })}
          </TableBody>
        </Table>
        <br />
        <div>
          <Pagination
            title="callDetailsPagination"
            totalRecords={this.props.callDetailsData.length}
            recordsPerPage={10}
            currentPage={this.state.currentPage}
            onClickPage={this.onClickPage}
            thresholdPageBtns={5}
          />
        </div>
      </div>
    );
  }
}

CallDetails.propTypes = {
  classes: stylesToPropType(styles()).isRequired,
  callDetailsData: PropTypes.array.isRequired,
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  client: PropTypes.object.isRequired,
};

export default withStyles(styles)(withApollo(CallDetails));
